import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import ProposalForm from '../proposal_form/ProposalForm';
import { Form } from '@ant-design/compatible';
import { getQuoteRestCrudThunksContractorId } from '../quote_utils/QuoteUtils';

const queryString = require('qs');

class EditWorkOrderProposalPage extends React.Component<any, any> {
	componentDidMount() {
		const { match, getProposal } = this.props;
		const proposalId = match.params.proposalId;
		getProposal(proposalId);
	}

	render() {
		const { history, proposal, fetching, userType, match, isClientView } = this.props;
		const workOrderId = match.params.id;

		return [
			<LogOnMountWithStandardEventProperties eventType="visited supplier edit proposal page" />,
			<EditPage
				title="Edit Proposal"
				formComponentProps={{
					formData: {
						...proposal,
						workOrderId: workOrderId,
						isClientView: true,
					},
					onSuccess: (rec) => {
						history.push(`/${userType}/workOrders/detail/${workOrderId}/quotes`);
					},
				}}
				fetching={fetching}
				FormComponent={ProposalForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	proposal: state.proposals.detail,
	fetching: state.proposals.fetching,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getProposal: (id) =>
		dispatch(getQuoteRestCrudThunksContractorId(ownProps.userType, false).readOne(id)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditWorkOrderProposalPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
